export default "__VITE_ASSET__BLhr8_GP__"